import api from "../axiosInstance";

// Get all sub-admins
export const getSubAdminsAPI = async () => {
  try {
    const response = await api.get("/admin/subAdmin");
    return response.data;
  } catch (error) {
    console.error("Error fetching sub-admins:", error);
    throw error;
  }
};

// Create a new sub-admin
export const createSubAdminAPI = async (payload) => {
  try {
    const response = await api.post("/admin/subAdmin", payload);
    return response.data;
  } catch (error) {
    console.error("Error creating sub-admin:", error);
    throw error;
  }
};

// Edit an existing sub-admin
export const editSubAdminAPI = async (payload) => {
  try {
    const response = await api.put("/admin/subAdmin", payload);
    return response.data;
  } catch (error) {
    console.error("Error editing sub-admin:", error);
    throw error;
  }
};

// Delete a sub-admin
export const deleteSubAdminAPI = async (subAdminId) => {
  try {
    const response = await api.delete(
      `/admin/subAdmin?subAdminId=${subAdminId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting sub-admin:", error);
    throw error;
  }
};

// Get all admins (including main admin)
export const getAllAdminsAPI = async () => {
  try {
    const response = await api.get("/admin/all");
    return response.data;
  } catch (error) {
    console.error("Error fetching all admins:", error);
    throw error;
  }
};
